export default __webpack_public_path__ + "static/teneriffa-explodiert-d5da8faf60785bb5e72199636d828fad.jpg";